import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const reportsRoutesDictionary = moduleRouteDictionaryFactory(
  'reports',
  'reports',
  {
    cardsShipped: 'cards-shipped',
  },
);
